/* Display and keyboard enhancements only. store-finder.js owns the live data and map. */
(() => {
  'use strict';

  const root = document.querySelector('.dama-store-finder');
  const list = root?.querySelector('[data-finder-list]');
  if (!list) return;

  const enhanceCards = () => {
    list.querySelectorAll('.stores__list-item').forEach((card) => {
      const name = card.querySelector('strong');
      if (name && !name.hasAttribute('tabindex')) {
        name.tabIndex = 0;
        name.setAttribute('role', 'button');
        name.setAttribute('aria-label', `${list.dataset.mapAction}: ${name.textContent.trim()}`);
      }

      card.querySelectorAll('a').forEach((link) => {
        const href = (link.getAttribute('href') || '').trim();
        if (/^www\./i.test(href)) link.setAttribute('href', `https://${href}`);
        else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(href) && !/^mailto:/i.test(href)) link.setAttribute('href', `mailto:${href}`);
      });

      const phoneLine = card.querySelector('.richtext > p:nth-child(3)');
      if (!phoneLine || phoneLine.querySelector('a')) return;
      const phone = phoneLine.textContent.trim();
      const dial = phone.replace(/[\s().-]/g, '');
      if (!/^\+?\d{6,15}$/.test(dial)) return;
      const link = document.createElement('a');
      link.href = `tel:${dial}`;
      link.textContent = phone;
      phoneLine.replaceChildren(link);
    });
  };

  list.addEventListener('keydown', (event) => {
    const name = event.target.closest('strong[role="button"]');
    if (!name || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    name.closest('.stores__list-item').click();
  });

  enhanceCards();
  const observer = new MutationObserver(enhanceCards);
  observer.observe(list, { childList: true });
})();
